import type { PendingIncomingPayment } from '@tectonics/prs/incoming-payment';
import { getSafeGateway } from '@tectonics/prs/core/gateway';

export function getGatewayVoucherCode(incomingPayment: PendingIncomingPayment): string | null | undefined {
  const gateway = getSafeGateway(incomingPayment);
  return gateway['voucher_code'];
}

export function getSafeGatewayVoucherCode(incomingPayment: PendingIncomingPayment): string {
  const code = getGatewayVoucherCode(incomingPayment);

  if (!code) {
    throw new Error('getSafeGatewayVoucherCode - there is no voucher code in the incoming payment');
  }

  return code;
}
